/**
 * Lazy-loaded site / participant auth route elements.
 */
import React from 'react';

export const Profile = React.lazy(() =>
  import('@/js/site/components/dashboards/Profile')
);
export const ProfileEdit = React.lazy(() =>
  import('@/js/site/components/dashboards/ProfileEdit')
);
export const VerifyEmail = React.lazy(() =>
  import('@/js/site/components/dashboards/VerifyEmail')
);
export const PasswordReset = React.lazy(() =>
  import('@/js/site/components/PasswordReset')
);
export const TokenLogin = React.lazy(() =>
  import('@/js/site/components/dashboards/TokenLogin')
);
export const ProfileNotificationSettings = React.lazy(() =>
  import('@/js/site/components/dashboards/ProfileNotificationSettings')
);
export const SitePage = React.lazy(() =>
  import('@/pages/site/site-page').then((m) => ({ default: m.SitePage }))
);
export const LoginBox = React.lazy(() =>
  import('@/js/shared/components/loginbox')
);
export const AuthWall = React.lazy(() =>
  import('@/js/shared/components/AuthWall').then((m) => ({
    default: m.AuthWall,
  }))
);
export const OpenASK = React.lazy(() =>
  import('@/js/site/components/dashboards/OpenASK').then((m) => ({
    default: m.OpenASK,
  }))
);
